import * as development from "./development";
import * as staging from "./staging";
import * as production from "./production";
import moment from "moment";

export interface Environment {
  // Meeters about page
  meetersURL: string;
  version: string;
  baseURL: string;
  baseBackofficeURL: string;
  zoomApiKey: string;
  jitsiURL: string;
  whatsapp: {
    number: string;
    formatted: string;
  }
  showHandledLogs: boolean;
  assets: {
    meetersLogo: string;
    footerLogos: string[];
    logo: string;
    userPlaceholder: string;
    eventPlaceholder: string;
  };
  rooms: string[];
  mattermost: {
    URL: string;
    generalRoom: string;
    directMessagesPath: string;
  };
  appointments: {
    duration: number;
    startTime: string;
    endTime: string;
  };
  fairStartdate: moment.Moment;
  fairEndDate: moment.Moment;
  firebase: {
    functionsURL: any;
    storage: {
      buckets: {
        default: string;
        resize: string;
      };
      paths: any;
    };
    config: any;
  };
}

let environment: any = {
  development: development,
  staging: staging,
  production: production,
};

let index = !!process.env.REACT_APP_ENV ? process.env.REACT_APP_ENV : "development";

export default environment[index].default as Environment;
